module.exports = __webpack_public_path__ + "media/images/common/ig-72c468e1029064fcf90159a8d6c6b5b2.svg";